function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 31,
  viewBox: "0 0 21 31",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0042AC",
  fillRule: "nonzero",
  d: "M17.927 3.112a10.417 10.417 0 0 0-14.853 0C-.402 6.634-.93 12.006 1.489 16.093l7.4 13.675c.89 1.644 2.333 1.641 3.222 0l7.4-13.675c2.419-4.087 1.89-9.459-1.585-12.98"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/map/ic-map-pin.svg";
export { SvgComponent as ReactComponent };